import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import jwt from 'jsonwebtoken';

import { ReactComponent as DashboardIcon1 } from '../../../../images/DashboardIcon1.svg';
// import { ReactComponent as DashboardIcon2 } from '../../../../images/DashboardIcon2.svg';
import { ReactComponent as DashboardIcon3 } from '../../../../images/DashboardIcon3.svg';
// import { ReactComponent as DashboardIcon4 } from '../../../../images/DashboardIcon4.svg';
// import { ReactComponent as DashboardIcon5 } from '../../../../images/DashboardIcon6.svg';
import ComingSoon from '../../../../images/comingSoon.png';
import {
  JobBoardIcon,
  DashboardInactive,
  JobBoardFilled,
  ListingActive,
  AppointmentFilled,
  AppointmentIcon,
  ReportsFilled,
  DashboardIcon4,
  PurchasesActive,
  Purchases,
  // SettingsActive,
} from '../../../../constants';

import './IconsMobile.scss';
import {
  checkInSubscription,
  hasPermission,
} from '../../../../components/Utils/helper';

export default function IconsMobile() {
  const [coming, setComing] = useState(false);
  const [roleId, setRoleId] = useState();
  const { pathname } = useLocation();
  // const comingSoon = () => {
  //   setComing(true);
  // };
  useEffect(() => {
    const userDataa = JSON.parse(localStorage.getItem('userData'));
    if (userDataa) {
      const { token: Token } = userDataa;
      if (Token) {
        const jwtDecodeToken = jwt.decode(Token);
        const role = jwtDecodeToken.roleId;
        setRoleId(role);
      }
    }
  }, []);
  return (
    <>
      <div className='iconMobileMain'>
        <div className='IconsMobile'>
          {/* Dashboard Icon */}
          <Link to='/dashboard' className='icon__anchor__tag'>
            {pathname === '/dashboard' ? (
              <DashboardIcon1 className='Icons' />
            ) : (
              <DashboardInactive className='Icons' />
            )}
          </Link>

          {/* Appointment Icon */}
          <Link to='/appointments' className='icon__anchor__tag'>
            {pathname === '/appointments' ? (
              <AppointmentFilled className='Icons' />
            ) : (
              <AppointmentIcon className='Icons' />
            )}
          </Link>

          {/* JObboard Icon */}
          <Link to='/jobboard' className='icon__anchor__tag'>
            {pathname === '/jobboard' ? (
              <JobBoardFilled className='Icons' />
            ) : (
              <JobBoardIcon className='Icons' />
            )}
          </Link>

          {/* JObboard Icon */}
          <Link to='/reports' className='icon__anchor__tag'>
            {pathname === '/reports' ? (
              <ReportsFilled className='Icons' />
            ) : (
              <DashboardIcon4 className='Icons' />
            )}
          </Link>

          {checkInSubscription('purchaseOrderManagement') &&
            hasPermission('purchases', 'isAllowPo') && (
              <Link to='/purchases' className='icon__anchor__tag'>
                {pathname === '/purchases' ? (
                  <PurchasesActive className='Icons' />
                ) : (
                  <Purchases className='Icons' />
                )}
              </Link>
            )}

          {/* Listing Icon */}
          {roleId === 3 ? (
            <Link to='/reports' className='icon__anchor__tag'>
              {pathname === '/reports' ? (
                <ListingActive className='listing' />
              ) : (
                <DashboardIcon3 className='listing' />
              )}
            </Link>
          ) : (
            <Link to='/listing' className='icon__anchor__tag'>
              {pathname === '/listing' ? (
                <ListingActive className='listing' />
              ) : (
                <DashboardIcon3 className='listing' />
              )}
            </Link>
          )}

          {/* <DashboardIcon4 className='Icons' onClick={comingSoon} /> */}

          {/* Settings Icon */}
          {/* <Link to='/settings' className='icon__anchor__tag'>
            {pathname === '/settings' ? (
              <SettingsActive className='Icons' />
            ) : (
              <DashboardIcon5 className='Icons' />
            )}
          </Link> */}
        </div>
        {coming && (
          <div>
            {Swal.fire({
              // icon: { comingSoonImg },
              // iconHtml: `<img src=${ComingSoon}>`,
              imageUrl: `${ComingSoon}`,
              imageHeight: 60,
              imageWidth: 60,
              imageAlt: 'A tall image',
              title: 'Coming Soon!',
              text: 'This feature will be available soon',
              confirmButtonText: 'OK',
              customClass: {
                container: 'inspection__right__alert__swal',
                popup: 'CustomizeSwalPopup',
                icon: 'CustomizeSwalIcon',
                title: 'CustomizeSwalTitle',
                text: 'CustomizeSwalText',
                confirmButton: 'CustomizeSwalConfirmButton',
              },
            }).then(setComing(false))}
          </div>
        )}
      </div>
    </>
  );
}
